import React from 'react'
import s from './index.module.scss'

const NotFoundPage = () => {
    return (
        <div className={s.container}>
            <h1>Incorrect link to the gift certificate. Please check the link for accuracy.</h1>
            <h1>Некорректная ссылка на подарочный сертификат. Проверьте корректность ссылки.</h1>
            <h1>Enlace incorrecto al certificado de regalo. Verifique la precisión del enlace.</h1>
        </div>
    )
}

export default NotFoundPage
